<template>
    <div class="content">
      <el-row class="title">
        <span class="title-p">{{videoInfo.title}}</span>
      </el-row>
      <video-player v-bind:id = "id"/>

      <el-row >
        <el-col :span="2">
          <el-link :underline="false" v-bind:class="{fonthove:fontColor,likeColor:isLikeColor}" @click="like">
            <span class="iconfont">&#xec8c;</span>
            <span>{{videoInfo.countLike}}</span>
          </el-link>

        </el-col>
        <el-col :span="2" class="no-click">
            <span class="iconfont">&#xe7cd;</span>
            <span>{{videoInfo.countPlay}}</span>
        </el-col>
        <el-col :span="2" class="no-click">
          <span class="iconfont">&#xe848;</span>
          <span>{{videoInfo.uploadTime}}</span>
        </el-col>
      </el-row>
      <el-divider content-position="left">简介</el-divider>
      <el-row >
        <el-col :span="24" >
          <h4>讲师简介</h4>
<!--          <div class="tip">-->
          <div >
            <el-col :span="3" class="teacher">
              <el-avatar shape="circle " :size="100" fit="fit" :src="avatar"></el-avatar>
            </el-col>
            <el-col :span="21" class="teacher">
                <h5 style="color: #23b8ff">{{videoInfo.userName}}老师</h5>
                <p class="paragraph" style="overflow-wrap: break-word">{{videoInfo.userDes}}</p>
            </el-col>

          </div>
        </el-col>
        <el-col :span="24">
          <h4>视频简介</h4>
          <div class="tip">
<!--            <h5>视频简介</h5>-->
              <p class="paragraph">{{videoInfo.description}}</p>
          </div>
        </el-col>
      </el-row>
      <div class="comment-area">
        <div>
          <span class="comment-num">{{commentNum}}&nbsp;评论</span>
        </div>
        <el-tabs v-model="defaultSort" >
          <el-tab-pane label="按热度排序" name="heat"><comment  v-bind:id="this.id" v-bind:order="this.sortHeat"></comment></el-tab-pane>
          <el-tab-pane label="按时间排序" name="time"><comment v-bind:id="this.id" v-bind:order="this.sortTime"></comment></el-tab-pane>
        </el-tabs>

      </div>

    </div>
</template>

<script>
  import videoPlayer from '@/components/myPlayer'
  import comment from '@/components/comments/index'
  import { verifyVideoInfo,addLike} from '@/api/videoDetail'
  import { parseTime, formatTimes } from '@/utils/index'
    export default {
      name: "videoDetail",
      components: {comment,videoPlayer},
      props:[
        'id'
      ]
      ,
      data(){
        return{
          // baseUrl:'http://localhost:8100/helen/',
          defaultSort: 'heat',
          titleSearch: null,
          commentData: [],
          videoInfo:{},
          commentNum:'',
          sortTime:'time',
          sortHeat:'heat',
          fontColor:true,
          isLikeColor:false,
          avatar:''
        }
      },
      created() {
        this.verifyVideo(this.id)
      },
      methods:{
        verifyVideo(id){
          verifyVideoInfo(id).then(res=>{
            if (res.code === 20000){
              if(res.data!==0){
                res.data.video.uploadTime =parseTime(res.data.video.uploadTime,"{y}-{m}-{d}")
                this.videoInfo = res.data.video
                this.avatar=this.baseUrl+res.data.video.userAvatar
                this.commentNum = res.data.commentAndReplyNum
              }
            }
          })
        },
        like(){
          if(this.isLikeColor===true){
            this.$message({
              message:"您已经点过了哦",
              type:"info"
            })
          }else{
            addLike(this.id).then(res=>{
              if (res.code===20000){
                this.$message({
                  message:res.message,
                  type:"success"
                })
                this.verifyVideo(this.id)
                this.fontColor=false
                this.isLikeColor=true
              }
            })
          }
        }
      }
    }
</script>

<style scoped>
  @import "../../assets/icon/iconvideo/iconfont.css";
  @import "../../assets/icon/iconfont.css";
  .iconfont{
    font-size: 25px;
  }
  .content{
    width: 1200px;
    margin: auto;
  }
  div{
    text-align: left;
  }
  .tip {
    padding: 8px 16px;
    /*background-color: #ecf8ff;*/
    background-color: #f7f8fa;
    border-radius: 4px;
    border-left: 5px solid #dde2e4;
    margin: 20px 0;
  }
  .el-row{
    text-align: left;
    width: 98%;
    margin: auto;
  }
  .video-container{
    width: 98%;
    margin: auto;
  }
  .fonthove:hover{
    color: #00b5e5 !important;
  }
  .likeColor{
    color: #00b5e5 !important;
  }
  .fonthove {
    color:#757575 !important;
  }
  .no-click{
    color:#757575 !important;
  }
  .comment-area{
    width: 98%;
    margin: auto;
  }
  .comment-num{
    font-size: 18px;
    text-align: left;
  }
  .paragraph{
    font-family: Microsoft YaHei,Arial,Helvetica,sans-serif;
    font-weight: 500;
    font-size: 14px;
  }
  .title{
    margin-top: 16px;
    margin-bottom: -10px;
    margin-left: 16px;
    /*margin: 16px;*/
  }
  .title-p{
    font-size: 20px;
    font-weight: 600;
  }
  .teacher{
    margin: 20px 0px;
  }
  .el-avatar>img{
    width: 100%;
    display: block;
    height: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/views/videoDetail/videoDetail.vue